import type { SchemaValueType, SortSchemaValueType } from '@/services/types'

type RawSchemaSort =
  | string
  | {
      name: string
      fields?: RawSchemaSort[]
      values?: ('asc' | 'desc')[]
    }

type RawSchema = {
  name: string
  sort?: RawSchemaSort[]
}

export const makeSchemaSort = (sort: RawSchemaSort[]): SortSchemaValueType[] =>
  sort.map((rawItem) => {
    const item = typeof rawItem === 'string' ? { name: rawItem } : rawItem
    return item.fields
      ? {
          name: item.name,
          type: 'relation',
          values: null,
          fields: makeSchemaSort(item.fields),
        }
      : {
          name: item.name,
          type: 'field',
          values: item.values ?? ['desc', 'asc'],
          fields: null,
        }
  })

export const makeSchema = ({ name, sort }: RawSchema): SchemaValueType => ({
  name,
  schema: {
    sort: sort ? makeSchemaSort(sort) : [],
    searchFields: [],
    groupBy: [],
  },
})
